import React from 'react';
import { Text, useThemeName } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { ScrollView } from 'react-native';
import { CheckCircle2 } from 'lucide-react-native';
import { CustomButton } from '@/components';
import { COLORS } from '@/constants/colors';
import { LinearGradient } from '@/components/GradientView';
const RatingSummaryScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigation = useNavigation<any>();
  const themeName = useThemeName();

  const handleBack = () => {
    try {
      navigation.navigate('Home');
    } catch {}
    try {
      navigation.getParent()?.navigate('TabNavigator');
    } catch {}
  };

  const gradientColors = themeName === 'dark' 
    ? [COLORS.DARK_GRADIENT_START, COLORS.DARK_GRADIENT_END] 
    : [COLORS.LIGHT_GRADIENT_START, COLORS.LIGHT_GRADIENT_END];
  
  const cardBackgroundColor = themeName === 'dark' ? '$backgroundStrong' : 'white';
  const borderColor = themeName === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
  const textColor = themeName === 'dark' ? '$color' : '$gray10';
  const checkmarkColor = themeName === 'dark' ? '#ffffff' : '#111827';
  const statsBackgroundColor = themeName === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(19, 67, 107, 0.25)';
  const statsTextColor = themeName === 'dark' ? '#ffffff' : '#13436B';

  return (
    <LinearGradient
      colors={gradientColors}
      style={{ flex: 1 }}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
    >
      <ScrollView 
        style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        <YStack flex={1} paddingHorizontal="$4" paddingTop="$12" paddingBottom="$6" alignItems="center">
          <YStack
            width="100%"
            backgroundColor={cardBackgroundColor}
            borderRadius={20}
            padding="$5"
            elevation={6}
            shadowColor="rgba(0,0,0,0.15)"
            borderWidth={1}
            borderColor={borderColor}
          >
          <YStack alignSelf="center" width={180} height={180} borderRadius={90} alignItems="center" justifyContent="center" marginBottom="$2">
            <CheckCircle2 size={120} color={checkmarkColor} strokeWidth={0.5} />
          </YStack>

          <Text textAlign="center" fontSize={24} fontWeight="800" marginBottom="$2" fontFamily="Poppins" color={themeName === 'dark' ? '$color' : '#111827'}>
            {t('screens.rating.thanksTitle')}
          </Text>
          <Text textAlign="center" color={textColor} lineHeight={22} fontFamily="Poppins">
            {t('screens.rating.thanksSubtitle')}
          </Text>

          <YStack
            marginTop="$6"
            backgroundColor={statsBackgroundColor}
            borderRadius={18}
            paddingVertical={18}
            paddingHorizontal={16}
            space="$3"
          >
            <Text color={statsTextColor} fontWeight="800" fontSize={18} textAlign="center" fontFamily="Poppins">
              {t('screens.rating.statsTitle')}
            </Text>
            <Text textAlign="center" color={statsTextColor} fontFamily="Poppins">
              {t('screens.rating.meetingCount', { count: 12 })}
            </Text>
            <Text textAlign="center" color={statsTextColor} fontFamily="Poppins">
              {t('screens.rating.avgScore', { score: '4.8/5' })}
            </Text>
          </YStack>

          <YStack marginTop="$5" space="$2">
            <CustomButton
              backgroundColor="#5E809C"
              color="white"
              paddingVertical={14}
              borderRadius={12}
              onPress={handleBack}
            >
              {t('screens.rating.backToHome')}
            </CustomButton>

            <CustomButton
              backgroundColor="transparent"
              color="#5E809C"
              paddingVertical={14}
              borderRadius={12}
              onPress={() => navigation.navigate('ParticipantRating' as never)}
            >
              <YStack
                width="100%"
                backgroundColor="transparent"
                borderWidth={1}
                borderColor="#5E809C"
                borderRadius={12}
                paddingVertical={14}
                alignItems="center"
                justifyContent="center"
              >
                <Text color="#5E809C" fontFamily="Poppins">
                  {t('screens.rating.planNew')}
                </Text>
              </YStack>
            </CustomButton>
          </YStack>
        </YStack>

          <YStack marginTop="$3" width="100%" backgroundColor="transparent" padding="$3" borderRadius={12} borderWidth={1} borderColor="rgba(255,255,255,0.3)">
            <Text color="white" textAlign="center" fontFamily="Poppins">{t('screens.rating.hint')}</Text>
          </YStack>
        </YStack>
      </ScrollView>
    </LinearGradient>
  );
};

export default RatingSummaryScreen;


